import React from "react"
import Head404 from "../components/organisms/head-404/head404"


const NotFoundPage = () => (
      <Head404 />
)

export default NotFoundPage
